import RugCardStatus from './RugCardStatus'
export default RugCardStatus
